import React from "react";
import { makeStyles } from "helpers/StyleHelper";
import { IQuestion } from "services/KnowfullyAdminClient";
import { Box, Typography, useTheme } from "@mui/material";

const useStyles = makeStyles({
  injectedHtml: {
    "& > *:first-child": {
      marginTop: 0,
    },
    "& > *:last-child": {
      marginBottom: 0,
    },
  },
});

const HTMLQuestion = ({ question }: { question: IQuestion }) => {
  const styles = useStyles(useTheme());
  return (
    <Typography component="div">
      <Box
        sx={styles.injectedHtml}
        dangerouslySetInnerHTML={{ __html: question.value }}
      />
    </Typography>
  );
};

export default HTMLQuestion;
